/**
 * DrumKitGraphic — renders a FRONT-VIEW Drum Kit from a DrumKitConfig.
 * Used both in the on-stage element render and the editor preview.
 * Square viewBox 0 0 100 100; `color` tints the drums.
 */
import type { DrumKitConfig } from './drumKitConfig';
import { buildDrumKitSvg, defaultDrumKit } from './drumKitConfig';

export interface DrumKitGraphicProps {
  config: DrumKitConfig | null | undefined;
  color: string;
  size?: number;
}

export function DrumKitGraphic({ config, color, size = 120 }: DrumKitGraphicProps) {
  const safe = config && typeof config === 'object' && config.counts ? config : defaultDrumKit();
  return (
    <svg
      width={size}
      height={(size * 100) / 116}
      viewBox="-8 0 116 100"
      preserveAspectRatio="xMidYMid meet"
      style={{ color }}
      role="img"
      aria-label={`Drum kit (${safe.handedness === 'left' ? 'left-handed' : 'right-handed'})`}
      dangerouslySetInnerHTML={{ __html: buildDrumKitSvg(safe, color) }}
    />
  );
}
